export function isApiError(
  err: unknown,
): err is { status: number; response?: { error?: { message?: string } } } {
  return (
    typeof err === 'object' &&
    err !== null &&
    'status' in err &&
    typeof (err as Record<string, unknown>).status === 'number'
  );
}

export function getApiError(err: unknown): string {
  if (isApiError(err)) {
    const msg = err.response?.error?.message;
    if (msg) return msg;
    switch (err.status) {
      case 400:
        return 'Invalid request. Please check your input.';
      case 401:
        return 'Your session has expired. Please log in again.';
      case 403:
        return 'You do not have permission to perform this action.';
      case 404:
        return 'The requested resource was not found.';
      case 409:
        return 'This action conflicts with existing data.';
      case 429:
        return 'Too many requests. Please wait a moment and try again.';
      case 500:
        return 'An unexpected error occurred. Please try again later.';
      default:
        return 'An error occurred. Please try again.';
    }
  }
  if (err instanceof Error) return err.message;
  return 'An error occurred. Please try again.';
}
